"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var hooks_1 = require("../../hooks");
var Loader_1 = __importDefault(require("../Loader"));
var CarsEmpty_1 = __importDefault(require("../CarsEmpty"));
function CarsList(props) {
    var cars = props.cars, carsEmptyText = props.carsEmptyText, isZeroPageLoading = props.isZeroPageLoading, clearFilters = props.clearFilters, Item = props.Item, _a = props.type, type = _a === void 0 ? 'type' : _a;
    hooks_1.useRestoreScroll(type);
    if (isZeroPageLoading) {
        return (react_1.default.createElement("div", { className: "aui-CarsList-loader" },
            react_1.default.createElement(Loader_1.default, null)));
    }
    return (react_1.default.createElement("section", { className: "aui-CarsList" },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" }, (cars === null || cars === void 0 ? void 0 : cars.length) ? (cars.map(function (car) { return react_1.default.createElement(Item, { car: car, key: car.id }); })) : (react_1.default.createElement(CarsEmpty_1.default, { text: carsEmptyText, onClearFilters: clearFilters }))))));
}
exports.default = CarsList;
CarsList.displayName = 'CarsList';
CarsList.propTypes = {
    cars: prop_types_1.default.array,
    carsEmptyText: prop_types_1.default.node,
    isZeroPageLoading: prop_types_1.default.bool.isRequired,
    clearFilters: prop_types_1.default.func.isRequired,
    Item: prop_types_1.default.elementType.isRequired,
    type: prop_types_1.default.string,
};
